import { render } from "./Panels-panel.vue?vue&type=template&id=57b915ca&scoped=true&lang=pug"
import script from "./Panels-panel.vue?vue&type=script&setup=true&lang=js"
export * from "./Panels-panel.vue?vue&type=script&setup=true&lang=js"

import "./Panels-panel.vue?vue&type=style&index=0&id=57b915ca&scoped=true&lang=css"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b915ca"]])

export default __exports__